import styled from "styled-components";

export const SPricingCardsContainerSeparator = styled.div`
  width: 1px;
  align-self: stretch;
  background-color: var(--ui-03);
`;
